<!-- ── Panel : the delivery table ─────────────────────────────────────────────── -->
<section class="holes-view__panel" data-attr="holes-panel-delivery">

  @if (state.deliveriesError()) {
    <div class="delivery-notice delivery-notice--error">
      <span>{{ 'HOLES_TAB.DELIVERY_LOAD_ERROR' | translate }}</span>
      <button type="button" class="delivery-notice__retry" (click)="retry()">{{ 'HOLES_TAB.RETRY' | translate }}</button>
    </div>
  }
  @if (logError()) {
    <div class="delivery-notice delivery-notice--error">
      <span>{{ 'HOLES_TAB.DELIVERY_LOG_ERROR' | translate }}</span>
    </div>
  }

  <div class="holes-view__head">
    <div class="holes-view__columns">
      <app-button-list
        [items]="allColumns"
        [selectedKeys]="visibleColumnKeys()"
        (selectionChange)="onColumnsChange($event)"
        iconSrc="assets/icon/settings.svg"
        panelTitle="QAQC_TAB.COLUMNS" />
    </div>
  </div>

  <div class="holes-view__table">

    @if (rows().length) {
      <app-data-table
        [data]="rows()"
        [columns]="visibleColumns()"
        [searchTerm]="state.searchTerm()"
        [clickable]="true"
        rowKey="id"
        highlightedRowKey="id"
        [highlightedRowValue]="state.selectedDeliveryId()"
        (selectionLigne)="onRowClick($event)"
        sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
        sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
        sortIconFilter="brightness(0)">
        <ng-template tableCell="start" let-row>
          @if (isMissing(row.start)) {
            <span class="delivery-muted">{{ 'HOLES_TAB.DELIVERY_NOT_SET' | translate }}</span>
          } @else {
            <span class="delivery-when">
              <span>{{ row.start | date:'dd/MM/yyyy' }}</span>
              <span>{{ row.start | date:'HH:mm' }}</span>
            </span>
          }
        </ng-template>
        <ng-template tableCell="end" let-row>
          @if (isMissing(row.end)) {
            <span class="delivery-muted">{{ 'HOLES_TAB.DELIVERY_NOT_SET' | translate }}</span>
          } @else {
            <span class="delivery-when">
              <span>{{ row.end | date:'dd/MM/yyyy' }}</span>
              <span>{{ row.end | date:'HH:mm' }}</span>
            </span>
          }
        </ng-template>
        <ng-template tableCell="users" let-row>
          <span class="delivery-users">
            <span>{{ row.blaster }}</span>
            <small>{{ row.operators }}</small>
          </span>
        </ng-template>
        <ng-template tableCell="kg" let-row>{{ row.kg | number:'1.0-1' }}</ng-template>
        <ng-template tableCell="details" let-row>
          @if (row.canEdit) {
            <button type="button" class="delivery-details" data-attr="holes-delivery-details" (click)="onDetails(row, $event)">
              {{ row.details }}
              <img src="assets/icon/new_icon/arrow-right.svg" alt="">
            </button>
          }
        </ng-template>
      </app-data-table>
    } @else if (!state.deliveriesLoading() && !state.deliveriesError()) {
      <div class="holes-view__empty" data-attr="holes-delivery-empty">
        <p>{{ 'HOLES_TAB.DELIVERY_NO_DELIVERIES' | translate }}</p>
      </div>
    }
  </div>

</section>
